import React from 'react';
import { FaGraduationCap, FaRing, FaUmbrellaBeach, FaBullseye } from 'react-icons/fa';

const GoalProgressCard = ({ goal, formatCurrency }) => {
  const progress = goal.progress_percentage || 0;
  const goalTypeIcons = {
    education: FaGraduationCap,
    marriage: FaRing,
    retirement: FaUmbrellaBeach,
    custom: FaBullseye
  };
  const goalTypeColors = {
    education: 'text-blue-400 bg-blue-500/20',
    marriage: 'text-pink-400 bg-pink-500/20',
    retirement: 'text-orange-400 bg-orange-500/20',
    custom: 'text-purple-400 bg-purple-500/20'
  };
  
  const Icon = goalTypeIcons[goal.goal_type] || FaBullseye;
  const colorClass = goalTypeColors[goal.goal_type] || goalTypeColors.custom;
  
  return (
    <div className="bg-[#0F172A] rounded-lg p-4 border border-[#2D5A8F]">
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center space-x-3">
          <div className={`w-10 h-10 rounded-lg ${colorClass} flex items-center justify-center`}>
            <Icon className={colorClass.split(' ')[0]} />
          </div>
          <div>
            <p className="text-white font-medium">{goal.goal_name}</p>
            <p className="text-gray-400 text-xs capitalize">{goal.goal_type} Goal</p>
          </div>
        </div>
        <div className="text-right">
          <p className="text-gray-400 text-xs">Monthly SIP</p>
          <p className="text-[#FFD700] font-bold">{formatCurrency(goal.monthly_sip_required)}</p>
        </div>
      </div>
      
      {/* Progress Bar */}
      <div className="mb-3">
        <div className="flex items-center justify-between text-sm mb-1">
          <span className="text-gray-400">Progress</span>
          <span className="text-white font-medium">{Math.round(progress)}%</span>
        </div>
        <div className="w-full h-2 bg-gray-700 rounded-full overflow-hidden">
          <div 
            className={`h-full rounded-full transition-all duration-500 ${
              progress >= 75 ? 'bg-green-500' : progress >= 50 ? 'bg-yellow-500' : progress >= 25 ? 'bg-orange-500' : 'bg-red-500'
            }`}
            style={{ width: `${Math.min(progress, 100)}%` }}
          />
        </div>
      </div>
      
      {/* Goal Details */}
      <div className="grid grid-cols-3 gap-2 text-sm">
        <div>
          <p className="text-gray-400 text-xs">Target</p>
          <p className="text-white">{formatCurrency(goal.target_amount)}</p>
        </div>
        <div>
          <p className="text-gray-400 text-xs">Accumulated</p>
          <p className="text-green-400">{formatCurrency(goal.current_progress)}</p>
        </div>
        <div>
          <p className="text-gray-400 text-xs">Gap</p>
          <p className="text-yellow-400">{formatCurrency(goal.gap)}</p>
        </div>
      </div>
    </div>
  );
};

export default GoalProgressCard;
